<template>
  <div class="teleport">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Teleport",
  mounted() {
    const node = this.$mount().$el;
    document.body.appendChild(node);
  },
  destroyed() {
    const node = this.$mount().$el;
    node.remove();
  },
};
</script>

<style lang="scss" scoped>
</style>